import { Box } from 'src/components/Box';
import { Divider } from 'src/components/Divider';
import { Tab, Tabs } from 'src/components/Tabs';

export const DrawerTabs = ({ activeTab, onChange, children }) => {
  return (
    <Box>
      <Divider />
      <Tabs
        sx={{
          px: 2,
          py: 1,
        }}
        value={activeTab}
        onChange={(_event, value) => {
          onChange(value);
        }}
      >
        {children}
      </Tabs>
    </Box>
  );
};

export const DrawerTab = ({ value, label, ...restProps }) => (
  <Tab
    sx={{
      pb: 1,
      my: 0,
    }}
    key={value}
    value={value}
    label={label}
    {...restProps}
  />
);
